import {
  type DrugInteraction,
  EDrugInteractionLevel,
} from '@models/DrugInteraction';
import { OctagonAlert, TriangleAlert } from 'lucide-react';

interface IProps {
  data: DrugInteraction;
}

function Item({ data }: IProps) {
  return (
    <div className="border-b p-4">
      <h1 className="text-xl font-semibold">{`${data.origin} - ${data.interaction}`}</h1>

      {data.level === EDrugInteractionLevel.Light && (
        <div className="mb-2 mt-4 flex flex-row items-center gap-2">
          <OctagonAlert className="text-success" size={28} strokeWidth={1.5} />
          <p className="text-success text-base font-bold md:text-lg">
            Interação leve
          </p>
        </div>
      )}

      {data.level === EDrugInteractionLevel.Moderate && (
        <div className="mb-2 mt-4 flex flex-row items-center gap-2">
          <TriangleAlert
            className="text-secondary"
            size={28}
            strokeWidth={1.5}
          />
          <p className="text-secondary text-base font-bold md:text-lg">
            Interação moderada
          </p>
        </div>
      )}

      {data.level === EDrugInteractionLevel.Serious && (
        <div className="mb-2 mt-4 flex flex-row items-center gap-2">
          <OctagonAlert
            className="text-destructive"
            size={28}
            strokeWidth={1.5}
          />
          <p className="text-destructive text-base font-bold md:text-lg">
            Interação grave
          </p>
        </div>
      )}

      {data.level === EDrugInteractionLevel.Without ? (
        <div className="flex flex-col">
          <p className="mb-4 text-center text-sm md:text-left md:text-base">
            Não há registro de interação no nosso banco de dados, favor
            consultar a bula.
          </p>
          {data.labels.map((label) => (
            <a
              className="text-tertiary font-bold underline"
              href={label.link}
              key={label.uniqueId}
              target="_blank">{`Acessar bula - ${label.drug}`}</a>
          ))}
        </div>
      ) : (
        <div
          className="text-sm md:text-base"
          dangerouslySetInnerHTML={{
            __html: data.content.replaceAll('\n', '<br/>'),
          }}
        />
      )}
    </div>
  );
}

export default Item;
